import {
    Admin,
    Healthy,
    Welfare,
    NotFound,
    WalkInZm,
    ZmWindows,
    JobInfo,
    Crowd,
    Garden,
    SeaPurchase, CrossBorder, BrandAgency, BrandCreation
} from "@/pages";

const commonRoutes = [
    {
        pathName: '/index',
        component: Admin
    },
    {
        pathName: '/walkInZm',
        component: WalkInZm
    },
    {
        pathName: '/zmBusiness/crossBorder',
        component: CrossBorder
    },
    {
        pathName: '/zmBusiness/healthy',
        component: Healthy
    },
    {
        pathName: '/zmBusiness/crowd',
        component: Crowd
    },
    {
        pathName: '/zmBusiness/seaPurchase',
        component: SeaPurchase
    },
    {
        pathName: '/zmBusiness/brandAgency',
        component: BrandAgency
    },
    {
        pathName: '/zmBusiness/brandCreation',
        component: BrandCreation
    },
    {
        pathName: '/zmWindows',
        component: ZmWindows
    },
    {
        pathName: '/joinUs/welfare',
        component: Welfare
    },
    {
        pathName: '/joinUs/jobInfo',
        component: JobInfo
    },
    {
        pathName: '/garden',
        component: Garden
    },
    {
        pathName: '/404',
        component: NotFound
    }
]
export {
    commonRoutes
}